/**Get, Edit, Delete  Vendor Prospects */

export const GET_VENDOR_PROSPECTS = 'GET_VENDOR_PROSPECTS';
export const GET_VENDOR_PROSPECTS_SUCCESS = 'GET_VENDOR_PROSPECTS_SUCCESS';
export const DELETE_VENDOR_PROSPECTS = 'DELETE_VENDOR_PROSPECTS';
export const CREATE_VENDOR_PROSPECTS = 'CREATE_VENDOR_PROSPECTS';
export const EDIT_VENDOR_PROSPECTS = 'EDIT_VENDOR_PROSPECTS';

